// extracted by mini-css-extract-plugin
module.exports = {"yj-font-style":"yj-font-style--3LwLE","yjSideTrigger":"yjSideTrigger--3jwDU","yjSideNav":"yjSideNav--1_eiz","yjSideMenu":"yjSideMenu--3Mgb3","yjSubMenuItem":"yjSubMenuItem--1cq2t"};